export const notifications = {
  cantChangeRiskOrRows: "Can't change risk or rows while game is on",
};
